import React from 'react';
import { SvgIcon } from '@mui/material';

export default function DiscountIcon(props) {
  return (
    <SvgIcon sx={{ width: 48, height: 48 }} {...props}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_5963_102858)">
          <path
            opacity="0.5"
            d="M38.2288 18.5256L28.2746 8.89L31.2996 20.659C27.8841 26.4363 20.6582 38.8225 20.1258 39.3652C19.5934 39.9079 18.6255 39.9925 18.5296 39.8708C14.2015 37.2486 5.36553 31.5294 5.03046 31.3264C4.69538 31.1233 4.56236 30.3529 4.66292 30.117L16.3164 12.2729C18.8729 11.6586 24.1245 10.2852 24.6795 9.70526C25.2344 9.12534 24.6145 8.90244 24.2352 8.86348L15.2205 11.0363C11.618 16.9124 4.76527 28.9544 4.16303 30.1164C3.56079 31.2785 3.80296 31.9328 4.16303 32.1085L18.2823 40.8821C23.2995 40.9317 34.8222 41.6041 36.1511 41.5949C37.48 41.5857 37.8064 40.4417 37.8035 39.8708L38.2288 18.5256Z"
            fill="#F8F6FC"
          />
          <path
            d="M26.7248 8.64258L15.8115 11.5863L4.75439 29.6058C4.39514 30.1084 3.89218 31.2571 4.75439 31.8315C5.61661 32.4059 13.8735 37.3839 17.8941 39.8011C18.4407 40.1791 19.7914 40.6327 20.8212 39.4226C21.8511 38.2124 28.6097 26.3667 31.8602 20.5951L28.9959 9.5581"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle
            cx="23.9477"
            cy="15.8762"
            r="1.21443"
            transform="rotate(31.2102 23.9477 15.8762)"
            fill="#F8F6FC"
            stroke="#F8F6FC"
            strokeWidth="0.325927"
          />
          <circle cx="17.8925" cy="26.4883" r="5.98239" fill="#29EDFF" />
          <rect
            x="21.3359"
            y="24.6504"
            width="1.62908"
            height="7.59532"
            rx="0.81454"
            transform="rotate(72.8103 21.3359 24.6504)"
            fill="#4520AB"
          />
          <circle
            cx="17.8928"
            cy="29.8246"
            r="1"
            transform="rotate(31.2102 17.8928 29.8246)"
            fill="#4520AB"
          />
          <circle
            cx="18.0695"
            cy="23.2777"
            r="1"
            transform="rotate(31.2102 18.0695 23.2777)"
            fill="#4520AB"
          />
          <line
            x1="28.5255"
            y1="8.03632"
            x2="30.907"
            y2="4.10561"
            stroke="#F8F6FC"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5963_102858">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
